document.addEventListener("DOMContentLoaded", function() {
	const urlParams = new URLSearchParams(window.location.search);
	const hash = window.location.hash;
	const isCustomerPosted = urlParams.get("customer_posted") === "true";
	if (isCustomerPosted && hash) {
		const hashValue = hash.substring(1);
		const target = document.getElementById(hashValue);
		const successMessage = target.querySelector('.custom-newsletter-success-message');
		if (successMessage) {
      successMessage.classList.remove('custom-newsletter-success-message')
		}
	}
});